import _ from 'lodash';
import update from 'react-addons-update'; // https://facebook.github.io/react/docs/update.html
import move from 'lodash-move';

export default function pages(state = {}, action) {
    switch (action.type) {
    case 'ADD_PAGE': {
        state.list.splice(state.list.length - 1, 0, action.newId);  // mutate state.list array !
        return {
            ...state,
            byId: {
                ...state.byId,
                [action.newId]: {
                    id: action.newId,
                    type: 2,
                    active: false,
                    draggable: true,
                    widgets: [],
                },
            },
        };
    }

    case 'DELETE_PAGE':
        return {
            ...state,
            list: _.without(state.list, action.id),
            byId: _.omit(state.byId, action.id),
        };

    case 'SET_ACTIVE_PAGE': {
        const byId = _.mapValues(state.byId, (page) => {
            return (page.id === action.id) ? {
                ...page,
                active: true,
            } : {
                ...page,
                active: false,
            };
        });
        return {
            ...state,
            activeId: action.id,
            byId: byId,
        };
    }

    case 'SET_EDITING_PAGE': {
        return update(state, {
            byId: {
                [action.id]: {
                    editing: { $set: action.value },
                },
            },
        });
    }

    case 'TIE_WIDGET_TO_PAGE': {
        const page = state.byId[action.id];
        return {
            ...state,
            byId: {
                ...state.byId,
                [action.id]: {
                    ...page,
                    widgets: [...page.widgets, action.widgetId],
                },
            },
        };
    }

    case 'DELETE_WIDGET':
        return {
            ...state,
            byId: _.forEach(state.byId, (page) => {
                if (_.includes(page.widgets, action.id)) {
                    page.widgets = _.without(page.widgets, action.id);
                }
            }),
        };

    case 'SORT_PAGES':
        return { ...state, list: move(state.list, action.oldIndex, action.newIndex) };

    case 'SORT_WIDGETS': {
        const widgetsList = state.byId[action.id].widgets;
        return update(state, {
            byId: {
                [action.id]: {
                    widgets: { $set: move(widgetsList, action.oldIndex, action.newIndex) },
                },
            },
        });
    }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/pages_reducers.js